import _ from 'lodash';
import GlobalAttributes from 'constants/GlobalAttributes';
import SupportedEventNames from 'constants/SupportedEventNames';

const INPUT_ATTRIBUTES = [
  'name',
  'type',
  'accept',
  'autoComplete',
  'autoFocus',
  'checked',
  'defaultChecked',
  'defaultValue',
  'disabled',
  'maxLength',
  'minLength',
  'pattern',
  'placeholder',
  'readOnly',
  'required',
  'size',
  'spellCheck',
  'step',
  'value',
];

const ALLOWED_PROPS = _.union(GlobalAttributes, SupportedEventNames, INPUT_ATTRIBUTES);

export default (props: any) => {
  return _.pick(props, ALLOWED_PROPS);
};
